module.exports = __webpack_public_path__ + "static/media/gift-aid-uk.bd5ac281.png";